exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "::ng-deep [type=\"checkbox\"]:checked + label:before {\n  border-right: 2px solid #1594A6 !important;\n  border-bottom: 2px solid #1594A6 !important; }\n\n.main-card-padding {\n  margin: 0 auto;\n  width: 100%;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center; }\n\n.error-icon {\n  color: #cb6f67;\n  margin: 0 auto; }\n\n.invalid {\n  border-bottom: 1px solid #cb6f67 !important;\n  box-shadow: 0 1px 0 0 #cb6f67 !important; }\n\n::ng-deep div.invalid {\n  color: #cb6f67 !important; }\n\n.headline {\n  color: #1594A6;\n  margin-bottom: 0px;\n  margin-top: 0px; }\n\n.checkbox-red-border {\n  border-left: 1px solid red; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /agir/src/app/components/registration/registration.component.scss
// module id = ../../../../../src/app/components/registration/registration.component.scss
// module chunks = main